import { render, staticRenderFns } from "./SMS.vue?vue&type=template&id=323a616e&scoped=true&"
import script from "./SMS.vue?vue&type=script&lang=js&"
export * from "./SMS.vue?vue&type=script&lang=js&"
import style0 from "./SMS.vue?vue&type=style&index=0&id=323a616e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323a616e",
  null
  
)

export default component.exports